
import {Vue, Component} from 'vue-property-decorator';
import {dictApi, dictInstrumentApi, userApi} from "@/api/organization";
import {integrityApi} from "@/api/integrity";

const {regionData, CodeToText} = require("@/js/region/region");
import SelectMechanism from "@/components/SelectMechanism.vue";
import ckeditor from "@/components/AllCkeditorComponent.vue";
import baseUrl, {imageUrl} from "@/constants";
import IntegrityDemoDialog from "@/views/integrity/integrityDemoDialog.vue";

@Component({
  components: {
    IntegrityDemoDialog,
    ckeditor, SelectMechanism
  }
})
export default class Order extends Vue {
  private saveShow = true;
  private organizations = [];// 企业列表
  private showQuery = false;
  private regionData = regionData;
  private showInfoDialog = false;
  private listEdit = false;
  private CodeToText = CodeToText;
  baseUrl = baseUrl
  imageUrl = imageUrl
  private queryParams = {
    orgName: '',
    region: '',
    current: 1,
    size: 10,
    total: 0
  }
  private orgInfoDefault = {
    orgNameId: '',
    orgId: '',
    orgName: '',
    title: '',
    logo: '',
    photo: '',
    introduction: '',
    culture: '',
    integrityMeasurement: ''
  }

  private orgInfo = Object.assign({}, this.orgInfoDefault);

  mounted() {
    // 加载企业列表
    this.loadData();
    this.haveRight();
  }

  loadData() {
    this.tableClearSelect();
    integrityApi.listCultural(this.queryParams).then((r: any) => {
      const res = r.data;
      if (res.result === 0) {
        this.queryParams.total = res.data.total;
        this.organizations = res.data.records;
      }
    });

  }

  reset() {
    this.queryParams.orgName = '';
    this.queryParams.region = ''
    this.loadData();
  }

  onAdd() {
    this.orgInfo = Object.assign({}, this.orgInfoDefault);
    this.showInfoDialog = true;
  }

  changeOrg(val: any) {
    this.orgInfo.orgId = val.mechanismId;
    this.orgInfo.orgNameId = val.mechanismNameId;
    this.orgInfo.orgName = val.mechanismName;
  }

  onEdit() {
    if (!this.isCheckedOne()) {
      return;
    }

    const item = this.selectedItems[0] as any;
    integrityApi.getCultural({
      id: item.id
    }).then((r: any) => {
      const res = r.data;
      if (res.result === 0) {
        this.orgInfo = Object.assign({}, this.orgInfoDefault, res.data);
        this.showInfoDialog = true;
      }
    })
  }

  detailObj = {
    dialog: false,
    data: {} as any
  }

  onToDetail(row: any) {
    (this.$refs.integrityDemoDialogRef as any).setData(row)
    // this.detailObj.data = Object.assign({}, this.orgInfoDefault, row);
    // this.detailObj.dialog = true;
    // this.saveShow = false;
    // this.orgInfo = Object.assign({}, this.orgInfoDefault, row);
    // this.showInfoDialog = true;
  }

  onClose() {
    this.saveShow = true;
    this.orgInfo = Object.assign({}, this.orgInfoDefault);
    let form = this.$refs.form as HTMLFormElement;
    form.resetFields();
    this.showInfoDialog = false;
  }

  onSave() {
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if (valid) {
        integrityApi.saveCultural(this.orgInfo).then((r: any) => {
          const res = r.data;
          if (res.result === 0) {
            this.$message.success("保存成功")
            this.showInfoDialog = false;
            this.loadData();
            this.onClose();
          }
        });
      }
    });

  }

  onDelete() {
    if (!this.isChecked()) {
      return;
    }
    this.$confirm("确实要删除选中的企业吗?", "确认操作").then(() => {
      integrityApi.deleteCultural({ids: this.selectedItems.map((i: any) => i.id).join(",")}).then((r: any) => {
        if (r.data.result === 0) {
          this.loadData();
        }
      });
    })
  }

  isCheckedOne() {
    if (this.isChecked()) {
      if (this.selectedItems.length !== 1) {
        this.$message.error("请先选择一条记录");
        return false;
      }
    }

    return true;
  }

  isChecked() {
    if (!this.selectedItems || this.selectedItems.length === 0) {
      this.$message.error("请先选择一条记录");
      return false;
    }

    return true;
  }

  private selectedItems = [];

  onSelectItem(selection: any, row: any) {
    this.selectedItems = selection;
  }

  tableClearSelect() {
    this.selectedItems = [];
    let $table = this.$refs.table as HTMLFormElement;
    if ($table) {
      $table.clearSelection();
    }
  }

  pageSizeChange(val: number) {
    this.queryParams.size = val;
    this.loadData();
  }

  pageCurrentChange(val: number) {
    this.queryParams.current = val;
    this.loadData();
  }

  indexMethod(index: any) {
    return (this.queryParams.current - 1) * this.queryParams.size + index + 1;
  }

  onUploadLogoSuccess(res: any) {
    if (res.result === 0) {
      this.orgInfo.logo = res.data;
    }
  }

  onUploadPhotoSuccess(res: any) {
    if (res.result === 0) {
      this.orgInfo.photo = res.data;
    }
  }

  haveRight(){
    const right = this.$store.state.userRights;
    right.forEach((e:any)=>{
      if(e.name == "cxjl_wenhua_edit"){
        this.listEdit = true;
      }
    })
  }

  private rules = {
    orgName: [{required: true, message: '请正确填写企业名称', trigger: 'change'}],
    title: [{required: true, message: '请输入标题', trigger: 'blur'}],
    logo: [{required: true, message: '请上传企业logo', trigger: 'blur'}],
    photo: [{required: true, message: '请上传企业图片', trigger: 'blur'}],
    introduction: [{required: true, message: '请输入企业概况', trigger: 'blur'}],
    culture: [{required: true, message: '请输入主要做法', trigger: 'blur'}],
    integrityMeasurement: [{required: true, message: '请输入诚信计量启示', trigger: 'blur'}]
  }
}
